import * as THREE from 'three';
import p5 from "p5";
import { QTreeRect } from '../myP5/drawer/QTreeRect';
import { Params } from '../data/Params';
import { AbsDOM } from './AbsDOM';


export class QTreeDispQuad extends THREE.Line {

    private static mat:THREE.LineBasicMaterial
    private static geo:THREE.BufferGeometry
    private domBg:AbsDOM;
    private domTxt:AbsDOM;
    
    private data:QTreeRect;
    //private visible:boolean=false;

   constructor(){

    if(QTreeDispQuad.mat==null){
        let material = new THREE.LineBasicMaterial({
            color: 0xffffff
        });
        material.linewidth=1;
        material.transparent=true;
//        material.opacity=0.8
        QTreeDispQuad.mat=material;    
    }

    if(QTreeDispQuad.geo==null){
        const points = [];
        points.push( new THREE.Vector3( 0, 0, 0 ) );
        points.push( new THREE.Vector3( 1, 0, 0 ) );
        points.push( new THREE.Vector3( 1, -1, 0 ) );
        points.push( new THREE.Vector3( 0, -1, 0 ) );
        points.push( new THREE.Vector3( 0, 0, 0 ) );
        
        const geometry = new THREE.BufferGeometry().setFromPoints( points );
        QTreeDispQuad.geo=geometry;  
    }
    
    super(QTreeDispQuad.geo, QTreeDispQuad.mat);

   }

   init(rect:QTreeRect){

    this.data = rect;

    this.domBg = new AbsDOM(
        document.createElement("div"),
        document.getElementById("domContainer"),
        100
    );
    this.domBg.x = rect.x;
    this.domBg.y = rect.y;
    this.domBg.width = rect.w;
    this.domBg.height = rect.h;

    this.domTxt = new AbsDOM(
        document.createElement("div"),
        document.getElementById("domContainer2"),
        101
    );
    this.domTxt.dom.style.pointerEvents="none";
    this.domTxt.dom.style.margin="1px"

    this.domTxt.fontSize = "9px"
    this.domTxt.x = rect.x;
    this.domTxt.y = rect.y;
    this.domTxt.width = rect.w;
    this.domTxt.height = rect.h;
    this.domTxt.hide();


    this.domBg.dom.onmouseover=()=>{
        //console.log("aa")
        //domTxt.style.display="block"
        this.domTxt.show();
        this.domBg.backgroundColor="rgba(0,0,255,1.0)";
    }
    this.domBg.dom.onmouseout=()=>{
        //domTxt.style.display="none"
        //domBg.style.color = "rgba(255,0,0,0.0)";
        this.domTxt.hide();
        this.domBg.backgroundColor="rgba(255,0,0,0.0)";
    }
    /*
    this.domBg.dom.ontouchstart=()=>{
        this.data.changeRule();//setRule(0);
        this.updateRule();
    }*/
    this.domBg.dom.onclick=()=>{
        this.data.changeRule();//setRule(0);
        this.updateRule();
    }

   
    this.data.dom = this;
    this.updateRule()

   
    this.visible=false;

   }

   private updateRule(){
    this.domTxt.text= ""+Params.zeroPadding(this.data.rule,3);
    // this.data.rule;
   }

   public show(){
    this.visible=true;
    this.domTxt.show();
    this.domTxt.color="#fff";
    this.updateRule();
    setTimeout(()=>{
        this.hide();
    },1000)
   }

   public hide(){
    this.domTxt.hide();
   }


   public update(){
    //this.dom.innerHTML="RULE"+this.data.rule;
   }

   public kill(){
    console.log("kill")
    //this.dom.remove();
    document.body.removeChild(this.domBg.dom);
    document.body.removeChild(this.domTxt.dom);

   }

}